<template>
  <!-- 顶部标签卡导航组件 -->
  <div class="Affix-Con">
    <span v-for="(item, index) in AffixList" :key="index" :class="['tags-view-item', { 'active': AffixClass == item.path }]"
      @click="GoPath(item)">
      {{ $t(`lang.router.${item.title}`) }} <i class="icon-Rectangle Icon" v-if="item.icon"
        @click.stop="DeleteAffix(index)"></i>
    </span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['websiteType'],
  data() {
    return {
      // 标签卡列表(title:菜单名称,path:菜单路径,icon:是否选中高亮)
      AffixList: [],
      AffixClass: this.$route.fullPath
    }
  },
  mounted() {
    //初始化当前路径
    this.AffixList.push({ title: this.$route.name, path: this.$route.fullPath, icon: true })
    this.AffixList = this.DeWeighting(this.AffixList)
  },
  methods: {
    //跳转点击菜单，切换样式
    GoPath(item) {
      this.$router.push({ path: item.path })
      this.AffixClass = item.path
    },
    //筛选重复对象
    DeWeighting(objArray) {
      var hash = {};
      //reduce方法有两个参数，第一个参数是一个callback，用于针对数组项的操作；
      //第二个参数则是传入的初始值，这个初始值用于单个数组项的操作。
      objArray = objArray.reduce(function (item, next) {
        //这是针对数组项操作的函数，对于每个数组项，reduce方法都会将其调用一次
        //可使用最多四个参数来声明回调函数（第一个参数：通过上一次调用回调函数获得的值;第二个参数：当前数组元素的值；第三个参数：当前数组元素的数字索引；第四个参数：包含该元素的数组对象）
        //这里只使用了两个参数，所以item和next分别代表上一次调用回调函数后的值和objArray项值
        hash[next.title] ? '' : hash[next.title] = true && item.push(next);//与func3逻辑相似 
        return item;
      }, []);
      //初始值是一个空对象，使用reduce方法返回的是空对象通过叠加执行之后的结果
      return objArray;
    },
    //删除Affix
    DeleteAffix(index) {
      //如果删除的是当前访问的页面Affix，后退到前面的页面.
      if (this.AffixList[index].path == this.AffixClass) {
        this.$router.push({ path: this.AffixList[index - 1].path })
      }
      this.$store.dispatch('deleteKeepAlive', this.AffixList[index].title)
      this.AffixList.splice(index, 1)
      
      
    }
  },
  watch: {
    '$route'(to, go) {
      //获取点击路径
      this.AffixClass = to.fullPath
      console.log(to);
      
      //如果进入设备详情
      if (to.name == 'Particulars') {
        //遍历数组，如果设备详情存在即删除重新添加
        this.AffixList.forEach((val, index) => {
          if (val.title == 'Particulars') {
            this.AffixList.splice(index, 1)
          }
        })
        this.AffixList.push({ title: to.name, path: to.fullPath, icon: true })
        this.AffixList = this.DeWeighting(this.AffixList)
      }
      //如果不是设备详情添加到数组里
      else {
        this.AffixList.push({ title: to.name, path: to.fullPath, icon: true })
        this.AffixList = this.DeWeighting(this.AffixList)
      }
    },
    websiteType: {
      immediate: true,
      handler() {
        if (this.websiteType === 'deviceManagement') {
          this.AffixList = [{ title: 'Index', path: '/dashboard', icon: false }]
        } else if (this.websiteType === 'cloudMonitor') {
          this.AffixList = [{ title: 'MonitoringScreen', path: '/cloudMonitor/cloudMonitorHome', icon: false }]
        }
      }
    }

  },
}
</script>
<style scoped>
.tags-view-item {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.active {
  background-color: #42b983;
  color: #fff;
  border-color: #42b983;
}

.active::after {
  content: '•';
}

.Icon {
  padding: 2px;
}

.Icon:hover {
  background-color: #b4bccc;
  border-radius: 50%;
}

.Affix-Con {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 0.2rem;
  background-color: #ffffff;
}
</style>
